// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BootstrapController from "./bootstrap_controller"
application.register("bootstrap", BootstrapController)

import ChartjsController from "./chartjs_controller"
application.register("chartjs", ChartjsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DeployClaimController from "./deploy_claim_controller"
application.register("deploy-claim", DeployClaimController)

import FabricWorkspace__AccessModalController from "./fabric_workspace/access_modal_controller"
application.register("fabric-workspace--access-modal", FabricWorkspace__AccessModalController)

import FabricWorkspaceFormController from "./fabric_workspace_form_controller"
application.register("fabric-workspace-form", FabricWorkspaceFormController)

import ProductionDeployController from "./production_deploy_controller"
application.register("production-deploy", ProductionDeployController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import SecretChangesController from "./secret_changes_controller"
application.register("secret-changes", SecretChangesController)
